import { createSelector } from "@reduxjs/toolkit";
import { sortBy } from "lodash";
import { Member } from "../../screens/GameScreen/utils/Game";
import { RootState } from "../store";

export const membersSelector = createSelector(
  (state: RootState) => state.game.game,
  (game) => {
    return sortBy<Member>(Object.values(game?.membersMap ?? []), "userId");
  }
);
